/** Return a dashboard route label without exposing record IDs or query strings. */
export function safeDashboardPath(value: string): string {
  try {
    const pathname = new URL(value, "https://dashboard.invalid").pathname;
    if (!pathname.startsWith("/dashboard") && !pathname.startsWith("/admin")) {
      return "/other";
    }

    return pathname
      .replace(/\/(clients|leads|questionnaires|forms|estimate-forms|contact-intakes)\/[^/]+(?=\/|$)/gi, "/$1/[id]")
      .replace(/\/client_[^/]+(?=\/|$)/gi, "/[client]")
      .replace(/\/[0-9a-f-]{36}(?=\/|$)/gi, "/[id]")
      .replace(/\/\d{6,}(?=\/|$)/g, "/[id]");
  } catch {
    return "/dashboard";
  }
}

/** Use only a stable query namespace. Never send the rest of the query key. */
export function safeDashboardQueryName(
  queryKey: readonly unknown[],
  telemetryName: unknown,
): string {
  const candidate =
    typeof telemetryName === "string" ? telemetryName : queryKey[0];
  if (typeof candidate !== "string") return "unlabelled";

  const name = candidate.trim();
  if (/^(?:client|lead|user|questionnaire|form)[_-]/i.test(name) || /^\d+$/.test(name)) {
    return "unlabelled";
  }

  return /^[a-z][a-z0-9_-]{0,63}$/i.test(name)
    ? name.toLowerCase()
    : "unlabelled";
}
